/**
 * Set title and favicon on browser tab.
 *
 * Interestingly, browser caching seems to work differently depending on where
 * this is executed. Using it in the routing path loader will cause the favicon
 * to get cached, so the default favicon won't flash when loading after the first load.
 * Executing this in a component doesn't seem to cache it however.
 *
 * @param title - Browser tab title.
 * @param favicon - Browser tab favicon.
 */
export const setBrowserTabSettings = async (
  title?: string,
  favicon?: string,
): Promise<void> => {
  if (title) {
    document.title = title;
  }

  if (!favicon) return;

  const link: HTMLLinkElement | null =
    document.querySelector("link[rel*='icon']");

  if (link) {
    link.href = favicon;
  }
};
